import { graphql, useStaticQuery } from 'gatsby';

const useDefaultCallToAction = () => {
  const { contentfulCallToAction } = useStaticQuery(graphql`
    query {
      contentfulCallToAction(
        internalName: { eq: "CTA - Get Demo - Demo Modal | Request a personalized demo" }
      ) {
        ...CallToAction
      }
    }
  `);

  return contentfulCallToAction;
};

export default useDefaultCallToAction;
